import { c as _c } from "react/compiler-runtime";
import { useState, useEffect, useCallback } from "react";
import { RecurringDonation } from "../../../../shared/components/Widget/types/Enums";
export interface FormData {
  amount: number | null;
  message: string;
  messageSenderName: string;
  showName: boolean;
  email: string;
  ssn: string;
  taxDeduction: boolean;
  newsletter: boolean;
  paymentMethod: PaymentMethodString;
  privacyPolicyAccepted: boolean;
  recurring: RecurringDonation;
}
export type PaymentMethodString = "bank" | "vipps" | "quickpay_card" | "quickpay_mobilepay" | "dkbank";
export function useFundraiserForm(paymentMethods, taxDeductionMinAmount) {
  const $ = _c(12);
  let t0;
  if ($[0] !== paymentMethods[0]) {
    t0 = {
      amount: null,
      message: "",
      messageSenderName: "",
      showName: false,
      email: "",
      ssn: "",
      taxDeduction: false,
      newsletter: false,
      paymentMethod: paymentMethods[0],
      privacyPolicyAccepted: false,
      recurring: RecurringDonation.NON_RECURRING
    };
    $[0] = paymentMethods[0];
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const [formData, setFormData] = useState(t0);
  let t1;
  let t2;
  if ($[2] !== formData.amount || $[3] !== taxDeductionMinAmount) {
    t1 = () => {
      if (typeof taxDeductionMinAmount === "number") {
        if (formData.amount && formData.amount >= taxDeductionMinAmount) {
          setFormData(_temp);
        } else {
          setFormData(_temp2);
        }
      }
    };
    t2 = [formData.amount, taxDeductionMinAmount];
    $[2] = formData.amount;
    $[3] = taxDeductionMinAmount;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== formData) {
    t3 = e => {
      const {
        name,
        value,
        type
      } = e.target;
      const checked = (e.target as HTMLInputElement).checked;
      setFormData({
        ...formData,
        [name]: type === "checkbox" ? checked : value
      });
    };
    $[6] = formData;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const handleInputChange = t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (field, value_0) => {
      setFormData(prev_1 => ({
        ...prev_1,
        [field]: value_0
      }));
    };
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  const updateField = t4;
  let t5;
  if ($[9] !== formData || $[10] !== handleInputChange) {
    t5 = {
      formData,
      setFormData,
      handleInputChange,
      updateField
    };
    $[9] = formData;
    $[10] = handleInputChange;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
function _temp2(prev_0) {
  return {
    ...prev_0,
    taxDeduction: false
  };
}
function _temp(prev) {
  return {
    ...prev,
    taxDeduction: true
  };
}